'use client';

import type { FieldErrors } from 'react-hook-form';
import type { StylesConfig } from 'react-select';

import { InfinityAsyncSelector } from '@/app/components/form/Selector/InfinityAsyncSelector';
import type { SelectorOption } from '@/app/components/form/Selector/types';
import { SelectorOptionTypes } from '@/app/components/form/Selector/types';
import type { AgentListItem } from '@/types/clientTasksApiTypes';
import { mapAgentOptions } from '@/utils/mapAgentOptions';

const portalStyles: Partial<StylesConfig<SelectorOption<string | number | null>, false>> = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

interface AgentSelectorProps {
  label: string;
  name?: string;
  placeholder?: string;
  value: SelectorOption<string> | null;
  onChange: (option: SelectorOption<string> | null) => void;
  clearOptionLabel?: string;
  className?: string;
  customStyles?: Partial<StylesConfig<SelectorOption<string | null>, false>>;
  disabled?: boolean;
  errors?: FieldErrors;
}

export const AgentSelector = ({
  label,
  name = 'agent_id',
  placeholder = 'Select team member',
  value,
  onChange,
  clearOptionLabel = 'Select team member',
  className,
  customStyles,
  disabled,
  errors,
}: AgentSelectorProps) => (
  <InfinityAsyncSelector<AgentListItem>
    label={label}
    name={name}
    errors={errors}
    placeholder={placeholder}
    disabled={disabled}
    optionType={SelectorOptionTypes.IMAGE}
    url="/api/agents/list"
    queryKey={['agents-infinite']}
    mapOptions={mapAgentOptions}
    value={value?.value ?? ''}
    option={value}
    className={className}
    onChange={(opt) => {
      const selected = opt as SelectorOption<string> | null;
      onChange(!selected || selected.value === null ? null : selected);
    }}
    clearOptionLabel={clearOptionLabel}
    isSearchable
    customStyles={{ ...portalStyles, ...customStyles } as Partial<StylesConfig<SelectorOption<string | number | null>, false>>}
    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
  />
);
